import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { Key } from 'react';

const FEATURE_KEY = 'knowledgeBase';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface KnowledgeBaseState {
  expandedKeys: Key[];
  selectedKey: string | undefined;
}

const initialState: KnowledgeBaseState = {
  expandedKeys: [],
  selectedKey: undefined,
};

export const KnowledgeBaseSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setExpandedKeys: (state, action: PayloadAction<Key[]>) => {
      state.expandedKeys = action.payload;
    },
    setSelectedKey: (state, action: PayloadAction<string>) => {
      state.selectedKey = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = KnowledgeBaseSlice.reducer;
const actions = KnowledgeBaseSlice.actions;

const state = (rootState: any): KnowledgeBaseState => rootState[FEATURE_KEY];

const expandedKeysSelector = createSelector(
  state,
  (state) => state.expandedKeys
);

const selectedKeySelector = createSelector(state, (state) => state.selectedKey);

export {
  FEATURE_KEY,
  actions,
  expandedKeysSelector,
  selectedKeySelector,
  reducer,
};
